import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { esES } from "@mui/material/locale";
import "@fontsource/open-sans";

import "./App.css";

import api from "./service/api";
import {
  login,
  logout,
  setUsuario,
  setMenu,
  setAcciones,
  selectAuth,
} from "./reducers/authSlice";
import Body from "./layout/Body";
import Loading from "./layout/Loading";

const theme = createTheme(
  {
    palette: {
      primary: {
        main: "#799F4F",
      },
      secondary: {
        main: "#9e9e9e",
      },
    },
    typography: {
      fontFamily: ['"Open Sans"', "Arial"].join(","),
      titulo: {
        fontSize: "17.5px",
        color: "#3c4b64",
      },
      tituloXL: {
        fontSize: "22px",
        color: "#768192",
      },
      cuerpo: {
        fontSize: "14px",
        color: "#3c4b64",
      },
      aclaracion: {
        fontSize: "11.2px",
        color: "#768192",
      },
      extra: {
        fontSize: "30px",
        color: "#768192",
      },
    },
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiButton: {
        variants: [
          {
            props: { variant: "verde" },
            style: {
              color: "#fff",
              backgroundColor: "#799F4F",
              "&:hover": {
                backgroundColor: "#ebedef",
                color: "#799F4F",
              },
            },
          },
          {
            props: { variant: "gris" },
            style: {
              color: "#fff",
              backgroundColor: "#636f83",
              "&:hover": {
                backgroundColor: "#ebedef",
                color: "#636f83",
              },
            },
          },
          {
            props: { variant: "azul" },
            style: {
              color: "#fff",
              backgroundColor: "#3399ff",
              "&:hover": {
                backgroundColor: "#ebedef",
                color: "#3399ff",
              },
            },
          },
          {
            props: { variant: "plata" },
            style: {
              color: "#3c4b64",
              backgroundColor: "#ebedef",
              "&:hover": {
                backgroundColor: "#d7d9db",
                color: "#fff",
              },
            },
          },
          {
            props: { variant: "amarillo" },
            style: {
              color: "#fff",
              backgroundColor: "#f9b115",
              "&:hover": {
                backgroundColor: "#ebedef",
                color: "#f9b115",
              },
            },
          },
          {
            props: { variant: "naranja" },
            style: {
              color: "#fff",
              backgroundColor: "#f05523",
              "&:hover": {
                backgroundColor: "#ebedef",
                color: "#f05523",
              },
            },
          },
        ],
      },
      MuiLink: {
        defaultProps: {
          underline: "hover",
        },
      },
    },
  },
  esES
);

const App = () => {
  const dispatch = useDispatch();
  const auth = useSelector(selectAuth);
  const salt = process.env.REACT_APP_LS_SALT;

  useEffect(() => {
    async function checkAuth() {
      if (localStorage.getItem("accessToken" + salt) != null) {
        try {
          let menu = await api.menuUsuario();
          let acciones = await api.accionesUsuario();
          dispatch(setUsuario(localStorage.getItem("usuario" + salt)));
          dispatch(setMenu(menu.data));
          dispatch(setAcciones(acciones.data));
          dispatch(login());
        } catch (error) {
          dispatch(logout());
        }
      } else {
        dispatch(logout());
      }
    }

    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (auth === false) {
      localStorage.removeItem("accessToken" + salt);
      localStorage.removeItem("refreshToken" + salt);
      localStorage.removeItem("usuario" + salt);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return (
    <BrowserRouter basename={String(process.env.PUBLIC_URL).trim()}>
      <ThemeProvider theme={theme}>
        {auth !== null ? <Body /> : <Loading />}
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
